<div class="flex justify-between mb-3">
	<app-anchor type="static" url=".." class="mr-2"
		><h2>APS Intake</h2></app-anchor
	>
	<h2 class="flex-1">/ Edit {{ title() }} brokerage</h2>
</div>
<app-container type="dark" class="mt-2">
	<div>
		<app-create-company-side-form
			[minify]="false"
			(onSubmit)="onSubmit($event)"
			(onCancel)="onCancel()"
			[name]="brokerage?.name"
			[company]="brokerage"
		>
		</app-create-company-side-form>
	</div>
</app-container>
